/* globals API_PREFIX,AUTH,USER_API_URL */

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.View.extend({
  events: {
    click: 'handle_click',
  },
  initialize: function () {
    _.bindAll(this, 'handle_click', 'open_project_link', 'go_to_webapp',
      'get_full_url', 'open_link');

    this.username = window.localStorage.getItem('USERNAME');
    this.api_key = window.localStorage.getItem('API_KEY');
    this.href = this.$el.attr('href');
    if (this.href[0] === '/') {
      this.href = API_PREFIX + this.href;
    }
  },

  handle_click: function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.href.indexOf(API_PREFIX) == 0) {
      // The url is a project URL, wrap it with nonce
      this.open_project_link();
    } else {
      // The url is to another site and is absolute open a browser to it_
      this.open_link(this.href);
    }
  },

  open_project_link: function () {
    // Get a nonce and use it to auto-login the user
    $.ajax({
      url: USER_API_URL + 'get_nonce/' + (AUTH ? '?auth=' + AUTH.auth : ''),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/x-www-form-urlencoded',
      data: { username: this.username, api_key: this.api_key }
    }).done(this.go_to_webapp);
  },

  open_link: function (url) {
    if (navigator.app) {
      navigator.app.loadUrl(url, { openExternal: true });
    } else {
      window.open(url, '_system');
    }
  },

  go_to_webapp: function (data, textStatus) {
    if (textStatus == 'success') {
      var next_url = this.href;
      if (AUTH) {
        next_url = next_url + ('?auth=' + AUTH.auth);
      }
      this.open_link(this.get_full_url(data, next_url));
    }
  },

  get_full_url: function (data, next_url) {
    return API_PREFIX + '/core/nonce_login/?nonce=' +
              encodeURIComponent(data.nonce) + '&username=' +
              encodeURIComponent(this.username) + '&next_url=' +
              encodeURIComponent(next_url) +
              (AUTH ? '&auth=' + encodeURIComponent(AUTH.auth) : '');
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/views/extra_mobile_link.js
// module id = 16
// module chunks = 0